import { createFileRoute } from "@tanstack/react-router";
import ThankYouSaint from "@/pages/ThankYouSaint";

const SITE_URL = "https://neurowellnesstms.com";

export const Route = createFileRoute("/thank-you-saint-google")({
  head: () => ({
    meta: [
      { name: "robots", content: "noindex, follow" },
      {
        title: "Thank You — Book Your Free SAINT® Consult | Neuro Wellness",
      },
      {
        name: "description",
        content:
          "Thanks for checking your SAINT® eligibility. Next step: book your free consult or call us at (954) 827-9793 in Coral Springs, FL At Neuro Wellness TMS.",
      },
      {
        property: "og:title",
        content: "Book Your Free SAINT® Consult",
      },
      {
        property: "og:description",
        content:
          "Next step: book your free SAINT® consult with Neuro Wellness TMS Centers of America.",
      },
      {
        property: "og:url",
        content: `${SITE_URL}/thank-you-saint-google`,
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: `${SITE_URL}/thank-you-saint-google` }],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <ThankYouSaint google />;
}
